import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserPlatformerDemo from 'src/games/demos/phaserPlatformerDemo/Main';

interface PlatformerDemoProps extends PageProps<{}> {
}

class PlatformerDemo extends React.Component<PlatformerDemoProps> {
    constructor(props: PlatformerDemoProps) {
        super(props);
        bindAllOfThis(this, PlatformerDemo.prototype);
    }

    render() {
        return (<div>
            <PhaserPlatformerDemo />
        </div>);
    }
}

export default PlatformerDemo;



// WEBPACK FOOTER //
// ./src/pages/game/demos/PlatformerDemo.tsx